import { z } from "zod";

/** Studio slug rules shared by the pipeline, SQL check constraint and the worker. */
export const SLUG_PATTERN = /^[a-z0-9](?:[a-z0-9-]{1,38}[a-z0-9])$/;

export interface StudioScope {
  slug: string;
  /** Always `/s/{slug}/` */
  path: string;
}

export function studioScopeFromUrl(scopeUrl: string): StudioScope {
  const { pathname } = new URL(scopeUrl);
  const match = /^\/s\/([^/]+)\//.exec(pathname);
  const slug = match?.[1];
  if (!slug || !SLUG_PATTERN.test(slug)) {
    throw new Error(`Service worker registered outside a studio scope: ${pathname}`);
  }
  return { slug, path: `/s/${slug}/` };
}

/** Static, non-personal files cached at install for offline launch of one studio. */
export function shellUrlsForScope(path: string): string[] {
  return [
    path,
    `${path}owner/`,
    `${path}manifest.webmanifest`,
    `${path}owner/manifest.webmanifest`,
    `${path}icons/icon-192.png`,
    `${path}icons/icon-512.png`,
  ];
}

export const pushPayloadSchema = z.object({
  title: z.string().min(1).max(120),
  body: z.string().max(400).default(""),
  url: z.string().max(500).optional(),
  tag: z.string().max(120).optional(),
});
export type PushPayload = z.infer<typeof pushPayloadSchema>;
